export default {
      id: "admin-usage",
      viewBox: "0 0 71 75",
      url: __webpack_public_path__ + "sprite.svg#admin",
      toString: function () {
        return this.url;
      }
    }